import { useRef } from "react";
import { Box } from "~/components/Box";
import { GradientOverlay, ScrollContainer } from "./ScrollContainer";
import { Flex } from "~/components/Flex";
import { QuickAction } from "../../utils/quickActions.utils";
import { Icon } from "~/components/Icon";
import { Text } from "~/components/Text";

export const QuickActionsScroller = ({
  actions,
  edgeMargin = "$3",
}: {
  actions: QuickAction[];
  edgeMargin?: string;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Box css={{ position: "relative" }} ref={scrollRef}>
      <ScrollContainer css={{ width: "100%" }}>
        <GradientOverlay direction="left" />

        {actions.map((action, index) => (
          <Flex
            key={action.label + index}
            justify="between"
            direction="column"
            onClick={action.action}
            css={{
              height: "100px",
              width: "100px",
              background: action.background,
              padding: "$2",
              borderRadius: "$rounded",
              flex: "0 0 100px",
              minWidth: "100px",
              minHeight: "100px",
              marginLeft: index === 0 ? edgeMargin : 0,
              marginRight: index === actions.length - 1 ? edgeMargin : 0,
            }}
          >
            <Flex justify="end">
              <Icon as={action.icon} css={{ fill: action.textColor }} />
            </Flex>
            <Flex direction="column" css={{ width: "100%" }}>
              <Text size="2" fw="600" css={{ color: action.textColor }}>
                {action.label}
              </Text>
            </Flex>
          </Flex>
        ))}

        <GradientOverlay direction="right" />
      </ScrollContainer>
    </Box>
  );
};
